import { ToothEndodonticsEnum } from "requests";

export const ENDODONTICS_OPTIONS = [
  { value: ToothEndodonticsEnum.PulpCapIndirect, label: "Pulp Cap (indirect)" },
  {
    value: ToothEndodonticsEnum.StandardRootCanal,
    label: "Standard root canal"
  },
  {
    value: ToothEndodonticsEnum.SurgicalRootCanal,
    label: "Surgical root canal"
  },
  { value: ToothEndodonticsEnum.VitalPulpotomy, label: "Vital Pulpotomy" }
];
